import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { INGREDIENT_SPECIAL_CASE_QUERY } from '../graphql/queries'
import { FETCH_INGREDIENT_SPECIAL_CASE } from '../redux/action-types'
import { cleanupFetchIngredientSpecialCaseDetails } from '../redux/actions'

const useIngredientSpecialCaseDetailsQuery = lazy => {
  const dispatch = useDispatch()
  const { isLoading, error, data } = useSelector(
    store => store.ingredients.ingredientSpecialCase,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        INGREDIENT_SPECIAL_CASE_QUERY,
        { id },
        dispatch,
        FETCH_INGREDIENT_SPECIAL_CASE,
      ),
    [dispatch],
  )

  useCleanupRedux(cleanupFetchIngredientSpecialCaseDetails)

  useEffect(() => {
    if (!lazy) {
      refetch()
    }
  }, [lazy, refetch])

  const queryState = { isLoading, error, data }
  return lazy ? [refetch, queryState] : queryState
}

export default useIngredientSpecialCaseDetailsQuery
